// extracted by mini-css-extract-plugin
export default {"pdfDownload":"fFj_shsTRcM82Mk2aM_6","pdfDownloadButton":"uotS4MHZwnRSB3ZxziKO"};